import { ISchedules } from '../../../services/journey.service';
import { formatOnlyDate } from '../../../lib/dayjs';

export default class AttendanceDeclarationModel {
  static getRecent(schedules: ISchedules[], quantity: number): ISchedules[] {
    return [...schedules]
      .sort((a, b) => new Date(b.dateStart).getTime() - new Date(a.dateStart).getTime())
      .slice(0, quantity);
  }

  static formatDate(dateStart: string): string {
    return formatOnlyDate(dateStart);
  }
}
